import React, {Component} from 'react'
import {connect} from 'react-redux'
import {get, post_response} from 'helper/request'
import {Button, Col, Input, message, Row, Select} from 'antd'
import {ArrowLeftOutlined, ArrowRightOutlined} from '@ant-design/icons'
import {isNull, notNull} from 'utils/utils'
import {loadOrganisations} from "../redux_actions/users.action";
import {urls} from "../utils/urls";

import 'asset/style/dashboard.css'
import 'asset/style/add_case.css'
import 'asset/style/theme/theme.scoped.scss'
import HistoryLink from "../component/common/HistoryLink";
import {error_manager} from "../helper/error_manager";

class OrganisationLevelVisiblePermissions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedOrganisation: null,
            inaccessiblePermissions: [],
            inputAvailable: '',
            inputSelected: '',
            allPermissions: [],
            allCategories: [],
            organisationNames: [],
        }

        this.AvailablePermSelectId = "avaiable-perm-select-id"
        this.ChosenPermSelectId = "chose-perm-select-id"
    }

    componentDidMount() {
        this.props.dispatch(loadOrganisations())
        get('/api/get_all_access_permission_categories/')
            .then(data => this.setState({allCategories: data['access_permission_categories']}))
        this.fetchAllAccessPermissions()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState?.selectedOrganisation !== this.state?.selectedOrganisation && notNull(this.state?.selectedOrganisation)) {
            this.fetchInaccessiblePermsForOrg()
        }

        if (prevProps?.allOrganisations !== this.props?.allOrganisations && notNull(this.props?.allOrganisations)) {
            this.setState({organisationNames: this.props?.allOrganisations?.map(org => org.name)})
        }
    }

    fetchAllAccessPermissions = () => {
        get(`/api/get_all_access_permissions/`)
            .then(data => this.setState({allPermissions: data["access_permissions"]}))
    }

    fetchInaccessiblePermsForOrg = async () => {
        let url = `${urls.GET_INACCESSIBLE_PERMISSIONS_FOR_ORGANISATION}${this.state.selectedOrganisation}/`;

        await get(url)
            .then(data => {
                const inaccessiblePermissions = data?.permissions
                this.setState({inaccessiblePermissions})
            })
    }

    addPermission = () => {
        const options = document.getElementById(this.AvailablePermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            inaccessiblePermissions: [...state.inaccessiblePermissions, ...selected]
        }))
    }

    removePermission = () => {
        const options = document.getElementById(this.ChosenPermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            inaccessiblePermissions: state.inaccessiblePermissions.filter(p => !selected.includes(p))
        }))
    }

    updateSelectedOrganisation = (org) => {
        if (!org) return
        this.setState({selectedOrganisation: org})
    }

    renderSelectedPermissions(inaccessiblePermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        let idx = 0
        for (let {name, label, category} of allPerms) {
            let elem = null
            if (!label?.toLowerCase()?.includes(hint?.toLowerCase())) continue

            if (inaccessiblePermissions.includes(name)) {
                elem = (
                    <option key={`selected_perm_${name}_${idx}`} value={name}>
                        {label}
                    </option>
                )
            }

            if (!elem) continue

            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push(elem)

            idx++
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <div>
                <Row span={5}>
                    <select multiple className="multi_select_box" id={this.ChosenPermSelectId}>
                        {sortedEntries.map(([name, permissions]) =>
                            <optgroup
                                label={allCategories.find(c => c.name === name)?.label}
                                key={`select_optgroup_${name}_${permissions.length}`}>
                                {permissions}
                            </optgroup>
                        )}
                    </select>
                </Row>
            </div>
        )
    }

    renderAvailablePermissions(inaccessiblePermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        for (let {name, label, category} of allPerms) {
            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push({name, label})
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <select multiple className="multi_select_box" id={this.AvailablePermSelectId}>
                {
                    sortedEntries
                        ?.map(([name, permissions]) => [name, permissions?.filter(p => p.label?.toLowerCase()?.includes(hint?.toLowerCase()))])
                        ?.map(([name, permissions]) =>
                            permissions.length > 0 ?
                                (<optgroup
                                    label={allCategories.find(c => c.name === name)?.label}
                                    key={`optgroup_${name}_${permissions.length}`}>
                                    {permissions?.map((p, idx) => {
                                        const isSelected = inaccessiblePermissions?.includes(p.name)
                                        return (
                                            <option
                                                disabled={isSelected}
                                                key={`unselected_perm_${p.name}_${idx}_${isSelected}`}
                                                value={p.name}
                                            >
                                                {`${p.label}`}
                                            </option>
                                        )
                                    })}
                                </optgroup>) : (<div></div>)
                        )
                }
            </select>)
    }

    savePermissions = () => {
        let url = `${urls.SET_INACCESSIBLE_PERMISSIONS_FOR_ORGANISATION}${this.state.selectedOrganisation}/`;
        let val = {"permissions": this.state.inaccessiblePermissions};

        post_response(url, val)
            .then(_ => {
                message.success("Saved for organisation")
            }).catch(err => {
            error_manager("Failed to save permissions for organisation", err)
        })
    }

    historyLinks = ([
        {
            label: "Manage Users",
            link: "/accesscontrol/",
        },
        {
            label: "Manage Permissions",
            link: "/orgperms/"
        }
    ])

    render() {
        return (<Row span={24} className="all-slides">
                <div className="history-link-wrapper">
                    <HistoryLink links={this.historyLinks} />
                </div>
                <div className="heading-style main-heading-style">
                    <b>Inaccessible Permissions</b>
                </div>
                <div>
                    <Row>
                        <Col>
                            <div>
                                <Row className="add-case-row">
                                    <Col span={5} className="add-case-row-header">
                                        <Row>
                                            <Col span={4}><b>Organisation</b></Col>
                                        </Row>
                                    </Col>
                                    <Col span={6}>
                                        <Select
                                            showSearch
                                            autoComplete="off"
                                            className="input-field-add-case"
                                            style={{color: 'black'}}
                                            onChange={(val) => this.updateSelectedOrganisation(val)}
                                            value={this.state.selectedOrganisation}
                                        >
                                            {/*{this.props.allOrganisations.map(({name, id}) =>*/}
                                            {/*    <Select.Option value={id}>{name}</Select.Option>*/}
                                            {/*)}*/}
                                            {this.state.organisationNames.map((name) =>
                                                <Select.Option value={name}>{name}</Select.Option>
                                            )}
                                        </Select>
                                    </Col>
                                </Row>
                                <Row className="add-case-row" type="flex">
                                    <Col span={9}>
                                        <Row span={12}>
                                            <Row span={5} className="add-case-row-header">
                                                <b>Available Permissions</b>
                                            </Row>
                                            <Row span={5} className="add-case-row-header">
                                                <Input
                                                    autoComplete="off"
                                                    className="input-field-add-case"
                                                    style={{color: 'black', width: '100%'}}
                                                    value={this.state.inputAvailable}
                                                    placeholder={'Search'}
                                                    onChange={(e) => this.setState({inputAvailable: e?.target?.value})}/>
                                            </Row>
                                            <Row span={5} className="add-case-row-header" push={3}>
                                                {this.renderAvailablePermissions(
                                                    this.state.inaccessiblePermissions,
                                                    this.state.inputAvailable?.trim()
                                                )}
                                            </Row>
                                        </Row>
                                    </Col>
                                    <Col
                                        offset={1}
                                        style={{
                                            display: 'flex',
                                            'align-items': 'center',
                                            'justify-content': 'center',
                                            'flex-direction': 'column',
                                            gap: '16px'
                                        }}>
                                        <Row>
                                            <Button
                                                type="default"
                                                onClick={this.addPermission}
                                                disabled={isNull(this.state.selectedOrganisation)}
                                            >
                                                <ArrowRightOutlined/>
                                            </Button>
                                        </Row>
                                        <Row>
                                            <Button
                                                type="default"
                                                onClick={this.removePermission}
                                                disabled={isNull(this.state.selectedOrganisation)}
                                            >
                                                <ArrowLeftOutlined/>
                                            </Button>
                                        </Row>
                                    </Col>
                                    <Col span={9} offset={1}>
                                        <Row span={12}>
                                            <Row span={5} className="add-case-row-header">
                                                <b>Inaccessible Permissions</b>
                                            </Row>
                                            <Row span={5} className="add-case-row-header">
                                                <Input
                                                    autoComplete="off"
                                                    className="input-field-add-case"
                                                    style={{color: 'black', width: '100%'}}
                                                    value={this.state.inputSelected}
                                                    placeholder={'Search'}
                                                    onChange={(e) => this.setState({inputSelected: e?.target?.value})}/>
                                            </Row>
                                            <Row span={5} className="add-case-row-header" push={3}>
                                                {this.renderSelectedPermissions(
                                                    this.state.inaccessiblePermissions,
                                                    this.state.inputSelected?.trim()
                                                )}
                                            </Row>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div>
                    <Button type="primary" ghost disabled={isNull(this.state.selectedOrganisation)}
                            onClick={this.savePermissions}>Save</Button>
                </div>
            </Row>
        )
    }
}

const mapStateToProps = state => ({
    allOrganisations: state.searchUserReducer.organisations,
})

export default connect(mapStateToProps)(OrganisationLevelVisiblePermissions)
